import * as angular from 'angular';
import Clipboard from 'clipboard';

export class Controller {

    /** @ngInject */
    constructor($rootScope, $scope, $timeout, $translate, ConfirmModal, Alert) {
        this.grantTypesTooltip = require('./grant-types-tooltip.html');
        this.$rootScope = $rootScope;
        this.$scope = $scope;
        this.$timeout = $timeout;
        this.$translate = $translate;
        this.ConfirmModal = ConfirmModal;
        this.Alert = Alert;
    }

    $onChanges() {
        this.init();
    }

    $onInit() {
        this.init();
        this.$timeout(() => this.watch());
        new Clipboard(".copyCli").on('success', () => {
            this.$scope.$apply(() => {
            this.Alert('success', 'global.data_copied')
            })
        })
        let baseURI = document.baseURI;
        this.oidcDiscoveryEndpoint = `${baseURI}${this.$model.apiKey}/.well-known/openid-configuration`;
    }

    init() {
        this.$model = this.applicationConfiguration;
        this.model = angular.copy(this.$model);
        this.applicationNamePattern = /^[^@]/;
    }

    notModified() {
        return angular.equals(this.$model, this.model);
    }

    addNoteAvailable() {
        return true;
    }

    onKeyUp($event) {
        if ($event.keyCode === 13 && this.form.$valid && !this.notModified()) {
            this.onEnter();
        }
    }

    metadataFileChanged() {
        if (this.metadataFile.size > 500000) {
            this.Alert('danger', 'Metadata XML file should be smaller than 500 KB');
            this.metadataFile = null;
        }
    }

    isMetadataUrlValid() {
        let metadataUrl = this.metadataUrl;
        return metadataUrl && this.$rootScope.webPattern.test(metadataUrl)
    }

    saveMetadataUrl() {
        this.isSaving = true;
        let messageKey = this.$translate('company.manage-application.configuration.upload-metadata.confirm.message', { metadataXml: 'METADATA URL' })
        let titleKey = this.$translate('company.manage-application.configuration.upload-metadata.confirm.title', { metadataXml: 'METADATA URL' })
        this.ConfirmModal({
            messageKey: messageKey,
            titleKey: titleKey
        })
            .then(() =>
                this.onSaveMetadata({$url: this.metadataUrl})
            )
            .finally(() => (this.isSaving = false));
    }

    saveMetadataFile() {
        this.isSaving = true;
        let messageKey = this.$translate('company.manage-application.configuration.upload-metadata.confirm.message', { metadataXml: 'METADATA XML' })
        let titleKey = this.$translate('company.manage-application.configuration.upload-metadata.confirm.title', { metadataXml: 'METADATA XML' })
        this.ConfirmModal({
            messageKey: messageKey,
            titleKey: titleKey
        })
            .then(() =>
                this.onSaveMetadata({$file: this.metadataFile})
            )
            .finally(() => (this.isSaving = false));
    }

    openUrl(url) {
        window.location.href = url;
    }

    watch() {
        this.$scope.$watch(
            () => this.model,
            () => {
                if (this.model.isEPM && this.model.epmAppSettings.canUserSetPassword) {
                    this.model.epmAppSettings.canUserViewPassword = true;
                }
                this.$timeout(() => this.onChange({$value: this.model, $invalid: this.form.$invalid}));
            },
            true
        );
    }
}



// WEBPACK FOOTER //
// ./src/portal/states/company/manage-application/configuration/application-configuration-form.controller.js